import React, { Component } from 'react'
import { connect } from 'react-redux'
// import ReactTooltip from 'react-tooltip'
// import { holeHelper } from '../../helpers'

import { massiveAssign } from '../../actions'

const initialState = {
  lot: '',
  property: '1'
}

class Massive extends Component {
  constructor () {
    super()
    this.state = initialState
  }

  massiveMove () {
    const s = this.state
    const list = this.props.dashboard.list
    const l = list.map((h) => h.id)
    this.props.massiveAssign({
      lot: s.lot,
      property: s.property,
      list: l
    })
  }

  render () {
    const { list } = this.props.dashboard
    const { lots } = this.props.detections
    const s = this.state
    return (
      <>
        <div className="search-form-bkg" onClick={() => this.props.showMassiveForm()}></div>
        <div className="search-form">
          <h1>Gestione massiva anomalie</h1>
          <ul className="list-filters">
            <li>
              <label>
                Associa {(list || []).length} anomalie al lotto
                <select
                  value={s.lot}
                  onChange={(e) => this.setState({ lot: e.target.value })}
                >
                  <option value=""></option>
                  {
                    (lots || []).map((t, index) => {
                      return (
                        <option value={t.id} key={index}>{t.name}</option>
                      )
                    })
                  }
                </select>
              </label>
            </li>
            {
              s.lot === '0' && (
                <li>
                  <label>
                  Mantieni proprietà
                    <select
                      value={s.property}
                      onChange={(e) => this.setState({ property: e.target.value })}
                    >
                      <option value="1">Si</option>
                      <option value="0">No</option>
                    </select>
                  </label>
                </li>
              )
            }
          </ul>
          <button
            className="lnk-login"
            onClick={() => this.massiveMove()}
            disabled={s.lot === ''}
          >
            Associa
          </button>
        </div>
      </>
    )
  }
}

function mapStateToProps (state) {
  return state
}

export default connect(mapStateToProps, { massiveAssign })(Massive)
